import { render, staticRenderFns } from "./BeneficiaryStep.vue?vue&type=template&id=315e6f88&scoped=true&"
import script from "./BeneficiaryStep.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryStep.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryStep.vue?vue&type=style&index=0&id=315e6f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e6f88",
  null
  
)

export default component.exports